import React, { useContext, useEffect, useState } from 'react'
import './Header.css'
import { Link } from 'react-router-dom'
import AuthContext from '../../../../product/context/auth/authContext'
import AlertContext from '../../../../product/context/alert/alertContext'
import { handleRedirectInternal } from '../../../../product/common/components'
import ControlHubContext from '@/product/context/controlHub/controlHubContext'
import { useHistory, useLocation } from 'react-router-dom'

const ControlPayment = (props) => {
    const controlHubContext = useContext(ControlHubContext)
    const authContext = useContext(AuthContext)
    const { user, isAuthenticated } = authContext

    const [pendingPayment, setPendingPayment] = useState(false)
    const [remainingDay, setRemainingDay] = useState(0)

    const history = useHistory()
    const location = useLocation()

    const {
        getPendingPayments,
        unpaid_payment,
        payCartStripe,
        responseStatus: responseStatusPayment,
        clearResponse: clearResponsePayment,
    } = controlHubContext

    useEffect(() => {
        if (isAuthenticated) {
            if (
                user?.emp_type === 'super_admin' ||
                user?.emp_type === 'admin'
            ) {
                getPendingPayments(
                    {
                        page: 1,
                        limit: 1,
                        order: 'asc',
                        orderby: 'pay.id',
                        filters: {
                            paid: {
                                value: '0',
                                type: 'in',
                                field: 'pay.paid',
                            },
                            isPlugin: {
                                value: '0',
                                type: 'in',
                                field: 'pay.isPlugin',
                            },
                        },
                    },
                    'topHeader'
                )
            }
        } else {
            setPendingPayment(false)
            setRemainingDay(0)
        }
    }, [isAuthenticated, user])

    useEffect(() => {
        if (unpaid_payment.from === 'topHeader') {
            if (unpaid_payment && unpaid_payment.records) {
                let remainingDate = 0
                if (unpaid_payment.records.length) {
                    const paymentValue = unpaid_payment.records.find((ele) => {
                        if (!ele.paid) {
                            const currentDate = new Date()
                            const dueDate = new Date(ele.due_date)
                            const timeDifferenceMs =
                                dueDate.getTime() - currentDate.getTime()
                            const remainingDays = Math.ceil(
                                timeDifferenceMs / (1000 * 3600 * 24)
                            )
                            console.log('timeDifferenceMs', timeDifferenceMs)

                            if (timeDifferenceMs > 0) {
                                ele.remainingDays = remainingDays
                                remainingDate = remainingDays
                                return ele
                            } else {
                                ele.remainingDays = 0
                                remainingDate = 0
                                return ele
                            }
                        }
                    })

                    setPendingPayment(
                        paymentValue !== 'undefined' && paymentValue !== null
                            ? true
                            : false
                    )
                    setRemainingDay(remainingDate)
                }
            }
        }
    }, [unpaid_payment])

    useEffect(() => {
        if (isAuthenticated) {
            if (pendingPayment) {
                if (!remainingDay) {
                    console.log(
                        'REDIRECT TRIGGERING window.location.pathname',
                        location
                    )
                    if (!location.pathname.includes('billing')) {
                        console.log('REDIRECT TRIGGERING 11111')
                        handleRedirectInternal(history, 'billing/all/0')
                    }
                }
            }
        }
    }, [location, isAuthenticated, pendingPayment, remainingDay])

    return (
        <>
            {pendingPayment ? (
                <>
                    {remainingDay ? (
                        <>
                            {remainingDay <= 3 ? (
                                <div className="paymentWarnCnt">
                                    <span className="material-icons">
                                        warning
                                    </span>{' '}
                                    Your payment is due in {remainingDay}{' '}
                                    {remainingDay === 1 ? 'day' : 'days'}.
                                    Failure to pay will affect Admin
                                    Functionalities. Please make your payment by
                                    clicking{' '}
                                    <Link to="/billing/all/0">HERE</Link>
                                </div>
                            ) : (
                                <div className="paymentDueCnt">
                                    <span className="material-icons">
                                        hourglass_empty
                                    </span>{' '}
                                    Your payment is due in {remainingDay}{' '}
                                    {remainingDay === 1 ? 'day' : 'days'}.
                                    Please make your payment by clicking{' '}
                                    <Link to="/billing/all/0">HERE</Link>
                                </div>
                            )}
                        </>
                    ) : (
                        <>
                            <div className="paymentExCnt">
                                <span className="material-icons">error</span>{' '}
                                The payment due date has been reached. Please
                                make your payment by clicking{' '}
                                <Link to="/billing/all/0">HERE</Link>
                            </div>
                        </>
                    )}
                </>
            ) : null}
        </>
    )
}

export default ControlPayment
